import { render, staticRenderFns } from "./MinesTile.vue?vue&type=template&id=ce305be4&scoped=true"
import script from "./MinesTile.vue?vue&type=script&lang=js"
export * from "./MinesTile.vue?vue&type=script&lang=js"
import style0 from "./MinesTile.vue?vue&type=style&index=0&id=ce305be4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce305be4",
  null
  
)

export default component.exports